<template>
  <div>
    <!-- METHOD HEADER & BADGE -->
    <div class="row">
      <api-header-badge-section :id="operation.id" :operation="operation" />
    </div>
    <!-- URL & SERVER DETAILS -->
    <div v-if="operation.server.variables" class="row">
      <api-server-section :id="`${operation.id}-server-vars`" :server="operation.server" data-cy="api-server" />
    </div>
    <!-- SECURITY SCHEMES -->
    <api-security-section :id="`${operation.id}-auth`" :security="operation.security" />

    <!-- PARAMETERS -->
    <api-parameters-section
      v-for="[type, parameters] in Object.entries(operation.parameters)"
      :id="`${operation.id}-${type}-params`"
      :key="type"
      :type="type"
      :parameters="parameters"
    />
    <!-- REQUEST BODY -->
    <api-request-body-section
      v-if="operation.requestBody"
      :id="`${operation.id}-req-body`"
      :contents="operation.requestBody"
    />
    <!-- RESPONSES -->
    <api-response-section
      v-if="operation.responses"
      :id="`${operation.id}-responses`"
      :responses="operation.responses"
    />
    <!-- CALLBACKS -->
    <div v-if="operation.callbacks">
      <api-callback-section
        v-for="callback in operation.callbacks"
        :id="`${operation.id}-${callback.id}`"
        :key="callback.id"
        :operation="callback"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { PropType } from 'vue';
import { OperationObject } from '@bifrost-dev-docs-mfe/common/types/apiDocs';
import ApiHeaderBadgeSection from '@/components/api/content/common/ApiHeaderBadgeSection.vue';
import ApiParametersSection from '@/components/api/content/operations/ApiParametersSection.vue';
import ApiRequestBodySection from '@/components/api/content/operations/ApiRequestBodySection.vue';
import ApiSecuritySection from '@/components/api/content/operations/ApiSecuritySection.vue';
import ApiResponseSection from '@/components/api/content/operations/ApiResponseSection.vue';
import ApiCallbackSection from '@/components/api/content/common/ApiCallbackSection.vue';
import ApiServerSection from '@/components/api/content/common/ApiServerSection.vue';

defineProps({
  operation: { type: Object as PropType<OperationObject>, required: true },
});
</script>
